import { API } from "../APIs/index";
import { TokenValidator } from "./TokenValidator";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { States } from "../helpers/States";
import areas from "../helpers/json/area.json";



export default class AdministratorService{
     

    tokens: any | Tokens;
    get = API.aggregator + "get/";
    post = API.aggregator + "post/";
    delete = API.aggregator + "delete/";
    put = API.aggregator + "put/";
    constructor() {
        this.tokens = TokenValidator();
      }


    async getAdmins(data: Pagination) {
        try {
            let response = await fetch(
              this.get +
                `AggregatorAdmin/getaggregatoradministrators/${data.page}/${data.pageSize}/${data.whereCondition}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.tokens.access_token}`,
                  "x-api-key": `${process.env.REACT_APP_API_KEY}`,
                },
              }
            );
      
            return await response.json();
          } catch (err) {
            throw err;
          }
    }

    async queryAdmins(data: Pagination) {
      try {
          let response = await fetch(
            this.get +
              `AggregatorAdmin/queryaggregatoradministrators/${data.page}/${data.pageSize}/${data.whereCondition}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.tokens.access_token}`,
                "x-api-key": `${process.env.REACT_APP_API_KEY}`,
              },
            }
          );
    
          return await response.json();
        } catch (err) {
          throw err;
        }
  }

    async createAdmin(data: any) {
        try {
            let response = await fetch(
              this.post + `AggregatorAdmin`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.tokens.access_token}`,
                  "x-api-key": `${process.env.REACT_APP_API_KEY}`,
                },
                body: JSON.stringify(data),
              }
            );
      
            return await response.json();
          } catch (err) {
            throw err;
          }
    }

    
    async updateAdmin(data: any) {
        try {
            let response = await fetch(
              this.put + `AggregatorAdmin`,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.tokens.access_token}`,
                  "x-api-key": `${process.env.REACT_APP_API_KEY}`,
                },
                body: JSON.stringify(data),
              }
            );
      
            return await response.json();
          } catch (err) {
            throw err;
          }
    }

    
    async getAdmin(data: any) {
        try {
            let response = await fetch(
              this.get + `AggregatorAdmin/${data}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.tokens.access_token}`,
                  "x-api-key": `${process.env.REACT_APP_API_KEY}`,
                },
              }
            );
      
            return await response.json();
          } catch (err) {
            throw err;
          }
    }
}